import { enumify, Enumify, EnumValue } from '@mews/enumify';

function BaseAppEvent() {}

const config = {
    Loaded: 'loaded',
    Opened: 'opened',
    Closed: 'closed',
    TrackingConsentsSet: 'trackingConsentsSet',
    StepDates: {
        route: 'dates',
        value: 'stepDates',
    },
    StepHotels: {
        route: 'properties',
        value: 'stepHotels',
    },
    StepRooms: {
        route: 'categories',
        value: 'stepRooms',
    },
    StepRates: {
        route: 'rates',
        value: 'stepRates',
    },
    StepSummary: {
        route: 'summary',
        value: 'stepSummary',
    },
    StepCheckout: {
        route: 'checkout',
        value: 'stepCheckout',
    },
    StepConfirmation: {
        route: 'confirmation',
        value: 'stepConfirmation',
    },
    AlternativeDatesOffered: 'alternativeDatesOffered',
    AvailableAlternativeDatesOffered: 'availableAlternativeDatesOffered',
    NoAvailableAlternativeDatesOffered: 'noAvailableAlternativeDatesOffered',
    OfferedDatesSelected: 'offeredDatesSelected',
    BookingPrepared: 'bookingPrepared',
    BookingFinished: 'bookingFinished',
    ReservationCreated: 'reservationCreated',
    LanguageCodeChanged: 'languageCodeChanged',
    CurrencyCodeChanged: 'currencyCodeChanged',
    EndDateSelected: 'endDateSelected',
    StartDateSelected: 'startDateSelected',
    PromoCodeSelected: 'promoCodeSelected',
    RoomSelected: 'roomSelected',
    SpaceTypeCountChanged: 'spaceTypeCountChanged',
    RoomOccupancyChanged: 'roomOccupancyChanged',
    ProductAdded: 'productAdded',
    ProductRemoved: 'productRemoved',
    PromotedServiceAdded: 'promotedServiceAdded',
    PromotedServiceRemoved: 'promotedServiceRemoved',
    AvailabilityLoaded: 'availabilityLoaded',
    ConfigurationSet: 'configurationSet',
    RoomAdded: 'roomAdded',
    RoomCountChanged: 'roomCountChanged',
    PromotedServiceCountChanged: 'promotedServiceCountChanged',
    Checkout: 'checkout',
    ThemeSet: 'themeSet',
    HotelLoaded: 'hotelLoaded',
    CategoryLightboxOpened: 'categoryGalleryOpened',
    // GA 4 - new actions
    ApplicationLoaded: 'ApplicationLoaded',
    VoucherAdded: 'VoucherAdded',
    PropertiesLoaded: 'PropertiesLoaded',
    CalendarLoaded: 'CalendarLoaded',
    FetchedWithOccupancy: 'FetchedWithOccupancy',
    CategoriesLoaded: 'CategoriesLoaded',
    RatesLoaded: 'RatesLoaded',
    ProductsLoaded: 'ProductsLoaded',
    PromotedServicesLoaded: 'PromotedServicesLoaded',
    SummaryLoaded: 'SummaryLoaded',
    DetailsLoaded: 'DetailsLoaded',
    BookingCreated: 'BookingCreated',
    ConfirmationLoaded: 'ConfirmationLoaded',
    FlexibleRatesFilterChanged: 'FlexibleRatesFilterChanged',
};

type Keys = keyof typeof config;
interface RouteValue {
    route: string;
    value: string;
}

type Value = string | RouteValue;

enumify<Keys, Value>(BaseAppEvent, 'AppEvent', config);

export const AppEvent = BaseAppEvent as unknown as Enumify<Keys, Value>;
export type AppEventEnumValue = EnumValue<Keys, Value>;
